import { Table } from "@/features/Table";
import {
  type F1StrategyMetadata,
  f1_strategy_metadata_columns,
} from "./columns";
import {
  type FilterF1StrategyMetadataSchema,
  FilterF1StrategyMetadata,
} from "./filter";
import { useLocation } from "react-router";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const F1StrategyMetadataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<F1StrategyMetadata, typeof FilterF1StrategyMetadataSchema>
      label="F1 Strategy Metadata"
      client={Clients.F1_QUANTILIA}
      table_name={Tables.F1_STRATEGY_METADATA}
      columns={f1_strategy_metadata_columns}
      filter={<FilterF1StrategyMetadata />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
